import { Button, Card, Col, Form, Input, Row, Typography, Steps } from "antd";
import React, { useState } from "react";
import styles from "./Login.module.css";
import { useDispatch } from "react-redux";
import { signupUser } from "../../redux/actions/user/signupUserAction";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

const { Step } = Steps;
const { Title } = Typography;

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();

  const steps = [
    {
      title: "Company Details",
      content: "company",
    },
    {
      title: "Admin Details",
      content: "user",
    },
  ];

  const onFinish = async (values) => {
    setLoader(true);
    // Get all form values including fields from previous steps
    const allValues = form.getFieldsValue();
    const resp = await dispatch(signupUser(allValues));
    if (resp === "success") {
      setLoader(false);
      // Redirect to login page after successful signup
      navigate("/auth/login");
    } else {
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoader(false);
    toast.error("Please fill all required fields correctly");
  };

  const next = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    try {
      // Validate current step fields
      const fieldsToValidate = currentStep === 0
        ? ["company_name", "address", "company_phone", "company_email"]
        : ["user_email", "user_phone", "password"];

      await form.validateFields(fieldsToValidate);
      setCurrentStep(currentStep + 1);
    } catch (error) {
      console.log("Validation failed:", error);
      // Don't show toast here, validation errors will show on fields
    }
  };

  const prev = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setCurrentStep(currentStep - 1);
  };

  const renderStepContent = () => {
    return (
      <>
        {/* Company Information Step */}
        <div style={{ display: currentStep === 0 ? "block" : "none" }}>
          <Title level={4} className="mb-2" style={{ textAlign: "center", color: "#1890ff", marginTop: "0" }}>
            Company Information
          </Title>
          
          <Form.Item
            className="mb-2"
            label="Company Name"
            name="company_name"
            rules={[
              {
                required: true,
                message: "Please input your company name!",
              },
            ]}
          >
            <Input size="large" placeholder="Enter company name" />
          </Form.Item>

          <Form.Item
            className="mb-2"
            label="Company Address"
            name="address"
            rules={[
              {
                required: true,
                message: "Please input your company address!",
              },
            ]}
          >
            <Input.TextArea rows={3} size="large" placeholder="Enter company address" />
          </Form.Item>

          <Form.Item
            className="mb-2"
            label="Company Phone"
            name="company_phone"
            rules={[
              {
                required: true,
                message: "Please input your company phone number!",
              },
              {
                pattern: /^[0-9]{10,15}$/,
                message: "Please enter a valid phone number!",
              },
            ]}
          >
            <Input size="large" placeholder="Enter company phone number" />
          </Form.Item>

          <Form.Item
            className="mb-2"
            label="Company Email"
            name="company_email"
            rules={[
              {
                required: true,
                message: "Please input your company email!",
              },
              {
                type: "email",
                message: "Please enter a valid email!",
              },
            ]}
          >
            <Input size="large" placeholder="Enter company email address" />
          </Form.Item>
        </div>

        {/* Admin Information Step */}
        <div style={{ display: currentStep === 1 ? "block" : "none" }}>
          <Title level={4} className="mb-2" style={{ textAlign: "center", color: "#1890ff", marginTop: "0" }}>
            Admin Information
          </Title>

          <Form.Item
            className="mb-2"
            label="Admin Email"
            name="user_email"
            rules={[
              {
                required: true,
                message: "Please input your email!",
              },
              {
                type: "email",
                message: "Please enter a valid email!",
              },
            ]}
          >
            <Input size="large" placeholder="Enter your email address" />
          </Form.Item>

          <Form.Item
            className="mb-2"
            label="Admin Phone"
            name="user_phone"
            rules={[
              {
                required: true,
                message: "Please input your phone number!",
              },
              {
                pattern: /^[0-9]{10,15}$/,
                message: "Please enter a valid phone number!",
              },
            ]}
          >
            <Input size="large" placeholder="Enter your phone number" />
          </Form.Item>

          <Form.Item
            className="mb-2"
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
              {
                min: 6,
                message: "Password must be at least 6 characters!",
              },
            ]}
          >
            <Input.Password size="large" placeholder="Enter password" />
          </Form.Item>
        </div>
      </>
    );
  };

  return (
    <>
      <Row className="card-row" justify="center" style={{ marginTop: "-20px" }}>
        <Col xs={24} sm={20} md={16} lg={12} xl={10}>
          <Card bordered={false} className={styles.card} style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
            <Title level={2} className="text-center" style={{ marginBottom: "1rem", marginTop: "0" }}>
              Sign Up
            </Title>
            
            <Steps current={currentStep} style={{ marginBottom: "1.5rem" }}>
              {steps.map((item) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>

            <Form
              form={form}
              name="signup"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              {renderStepContent()}

              <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginTop: "1rem" }}>
                {currentStep > 0 && (
                  <Button
                    htmlType="button"
                    size="large"
                    onClick={prev}
                    style={{ flex: 1 }}
                  >
                    Previous
                  </Button>
                )}
                {currentStep < steps.length - 1 ? (
                  <Button
                    type="primary"
                    htmlType="button"
                    size="large"
                    onClick={next}
                    style={{ flex: currentStep === 0 ? "none" : 1, marginLeft: "auto" }}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    loading={loader}
                    onClick={() => setLoader(true)}
                    style={{ flex: 1, marginLeft: currentStep === 0 ? "auto" : "0" }}
                    block={currentStep === 0}
                  >
                    Sign Up
                  </Button>
                )}
              </div>

              <Form.Item className="text-center mt-2">
                <Link to="/auth/login">Already have an account? Login here</Link>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Signup;
